import { api } from '@services';

const generateType = (actionType = 'CUSTOM', reducer = 'PAGE/FORMS') => `${reducer}/${actionType}`;

export const fetchPDF = (file = '', name = '') => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const data = res.info.file || '';

			const createLink = () => {
				const downloadLink = document.createElement('a');
				downloadLink.setAttribute('target', '_blank');
				downloadLink.href = `data:application/pdf;base64,${data}`;
				downloadLink.download = name;
				downloadLink.click();
			};

			// await dispatch({
			// 	type: generateType('CUSTOM'),
			// 	payload: {
			// 		...getState().page.forms,
			// 		file: data,
			// 	},
			// });

			await createLink();
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.forms,
					_file: status,
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.forms,
					file: '',
				},
			});
		};

		api.$pdf_get({ onOK, onStatus, onFail }, { file });
	};
};
